export function normalizePathSegment(path = '') {
  return path.split('/').filter(Boolean).join('/');
}
